import type { MicrosoftProps } from './types';
import logo from 'Assets/images/microsoft-icon.svg';
import {
  AZURE_GRAPH_APP_CLIENT_ID,
  IS_ELECTRON,
  REDIRECT_URL,
  MICROSOFT_SOURCE_SCOPES,
  AZURE_GRAPH_OAUTH_URL,
} from 'Constants/env';
import { has } from 'lodash';
import React, { useEffect, useState } from 'react';
import { handleCodeReceived, sendIpcLoginUrl } from 'Utils/ipcRendererEvents';
import { randomString } from 'Utils/random';
import ProviderButton from '../ProviderButton';

export const handleMicrosoftLogIn = ({ onLogin }) => {
  const scope = encodeURIComponent(
    MICROSOFT_SOURCE_SCOPES.filter((a) => a).join(' ')
  );

  const handleWebRedirection = () =>
    (window.location.href = microsoftRedirectionLink);

  const microsoftRedirectionLink = `${AZURE_GRAPH_OAUTH_URL}?
    client_id=${AZURE_GRAPH_APP_CLIENT_ID}&
    response_type=code&
    redirect_uri=${encodeURIComponent(`${REDIRECT_URL}/addressBook/sources`)}&
    response_mode=query&
    prompt=select_account&
    scope=${scope}&
    state=contacts&
    nonce=${randomString(6)}`;

  if (IS_ELECTRON && has(window, 'ipcRenderer')) {
    handleCodeReceived((code) => {
      onLogin(code);
    });
    sendIpcLoginUrl(microsoftRedirectionLink);
  } else {
    handleWebRedirection();
  }
};

const Microsoft = ({ person, testId }: MicrosoftProps): JSX.Element => {
  const [loading, setLoading] = useState(false);

  const onLogin = (code) => {
    if (loading) {
      return;
    }

    setLoading(true);

    person
      .sendCodeOfProvider(code, 'microsoft')
      .then((res) => {
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const { search } = window?.location;

    if (!IS_ELECTRON) {
      if (search.includes('code=')) {
        setLoading(true);
        const code = search.split('&').find((item) => !!item.includes('code'));

        person
          .sendCodeOfProvider(code.split('code=')[1], 'microsoft')
          .then((res) => {
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
          });
      }
    }
  }, []);

  return (
    <ProviderButton
      text="Sign in with Microsoft"
      logo={logo}
      isLoading={loading}
      onClick={() => {
        handleMicrosoftLogIn({ onLogin });
      }}
      testId={`${testId}-microsoft-buttonSignIn`}
    />
  );
};

export default Microsoft;
